export const MAX_EMAIL_LENGTH = 255;
